import classes from "./Events.module.scss";
import { EventsBody } from "./EventsBody/EventsBody";

export const EventsPage = () => {
  return (
    <main className={`${classes.events}`} id="main-content">
      <section className={classes.banner}>
        <div className={classes.banner__overlay}>
          <div className={classes.banner__pattern} aria-hidden="true" />
          <div className={classes.banner__body}>
            <h2 className={classes.banner__body__title}>
              Transforming Occasions Into Great <span>Memories</span>
            </h2>
            <p className={classes.banner__body__text}>
              We’re always looking for talented, passionate people to join our
              team. If you’re excited about travel and delivering exceptional
              experiences.
            </p>
          </div>
        </div>
      </section>
      {/* Title under banner */}
      <EventsBody />
    </main>
  );
};

export default EventsPage;
